import Vue from 'vue';

Vue.filter('fixedPrice', val => {
  if (typeof(val) === 'number' || typeof(val) === 'string' )  {
    return Number(val).toFixed(2)
  }
  return val
})
